import { metrics } from '@opentelemetry/api'
import { useEffect, useRef } from 'react'

import { INSTRUMENTATION_NAME } from '~/utils/observability'

const meter = metrics.getMeter(INSTRUMENTATION_NAME)

const renderCount = meter.createCounter('app.component.renders', {
    description: 'Total number of render cycles',
})

/**
 * Instruments Otel metrics to capture render counts for a component, with attributes to differentiate
 * mount vs. update renders and loading vs. data renders.
 *
 * @param name - A name, typically in the format of `Page.ComponentName` (e.g. OP.WeekView.Calendar), to provide context for the metric.
 * @param isLoading - A boolean indicating whether the component is currently loading data.
 */
export function useOtelRenderMetric(name: string, isLoading?: boolean) {
    const isMountRef = useRef(true)

    useEffect(() => {
        const phase = isMountRef.current ? 'mount' : 'update'
        isMountRef.current = false

        renderCount.add(1, {
            'di.component.path': name,
            'di.render.phase': phase,
            'di.render.content': isLoading ? 'loading' : 'data',
        })
    })
}
